import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SbomService } from '../../../Services/sbom.service';
import { SbomComponent, COMPONENT_TYPES, HASH_ALGORITHMS } from '../../../Models/sbom.model';

@Component({
  selector: 'app-sbom-component-form',
  templateUrl: './sbom-component-form.component.html',
  styleUrls: ['./sbom-component-form.component.css']
})
export class SbomComponentFormComponent {
  component: Partial<SbomComponent>;
  isEdit: boolean;
  saving = false;
  projectId: number;
  componentTypes = COMPONENT_TYPES;
  hashAlgorithms = HASH_ALGORITHMS;

  constructor(
    public dialogRef: MatDialogRef<SbomComponentFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { projectId: number; component?: SbomComponent },
    private sbomService: SbomService
  ) {
    this.projectId = data.projectId;
    this.isEdit = !!data.component?.id;
    this.component = data.component ? { ...data.component } : {
      name: '',
      version: '',
      supplier: '',
      partNumber: '',
      componentType: '',
      license: '',
      componentHash: '',
      hashAlgorithm: '',
      description: '',
      isCritical: false
    };
  }

  save(): void {
    if (!this.component.name?.trim()) return;
    this.saving = true;

    const payload = {
      name: this.component.name,
      version: this.component.version,
      supplier: this.component.supplier,
      partNumber: this.component.partNumber,
      componentType: this.component.componentType,
      license: this.component.license,
      componentHash: this.component.componentHash,
      hashAlgorithm: this.component.hashAlgorithm,
      description: this.component.description,
      isCritical: this.component.isCritical,
      endOfLife: this.component.endOfLife
    };

    if (this.isEdit) {
      this.sbomService.updateComponent(this.projectId, this.data.component!.id, payload).subscribe({
        next: () => { this.saving = false; this.dialogRef.close(true); },
        error: () => { this.saving = false; }
      });
    } else {
      this.sbomService.addComponent(this.projectId, payload).subscribe({
        next: () => { this.saving = false; this.dialogRef.close(true); },
        error: () => { this.saving = false; }
      });
    }
  }

  cancel(): void {
    this.dialogRef.close(false);
  }
}
